import {
    TimeRangeHeader,
    TimesheetDataCell,
    TimesheetDataRowWrapper
} from '../../../components';

const Header = () => {
    return (
        <TimesheetDataRowWrapper>
            <TimesheetDataCell sx={{ gridColumn: 'span 3' }}>
                Employee
            </TimesheetDataCell>
            <TimeRangeHeader sx={{ gridColumn: 'span 8' }} />
            <TimesheetDataCell
                sx={{ gridColumn: 'span 1', textAlign: 'center' }}
            >
                Total
            </TimesheetDataCell>
        </TimesheetDataRowWrapper>
    );
};

export default Header;
